import Modal from './Modal'

export default function Adult18Modal({ isOpen, onClose, onConfirm }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center gap-4">
        <div className="w-20 h-20 rounded-2xl bg-red-500/15 border border-red-500/30 flex items-center justify-center">
          <span className="text-3xl font-black text-red-400">18+</span>
        </div>
        <div>
          <p className="text-lg font-bold text-fg mb-1">Контент для взрослых</p>
          <p className="text-sm text-muted leading-relaxed">
            Этот раздел содержит материалы, предназначенные только для лиц старше 18 лет.
            Включая данный фильтр, вы подтверждаете своё совершеннолетие.
          </p>
        </div>
        <div className="w-full p-3 rounded-xl bg-red-500/8 border border-red-500/20">
          <p className="text-xs text-red-400 leading-relaxed">
            Если вам нет 18 лет — пожалуйста, не включайте этот фильтр.
          </p>
        </div>
        <div className="flex gap-3 w-full mt-1">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl text-sm font-semibold border border-line text-muted hover:text-fg hover:border-fg transition-colors"
          >
            Отмена
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl text-sm font-bold bg-red-500/15 text-red-400 border border-red-500/30 hover:bg-red-500/25 transition-colors"
          >
            Мне есть 18 лет
          </button>
        </div>
      </div>
    </Modal>
  )
}
